import BasicChart from "./basic-chart";

export default function SessionChart() {
  return <BasicChart url="/operation/get-session-report" chartType="line" />;
}
